import React, { useState } from 'react';
import { Button, Modal, Checkbox, Accordion } from 'app/components';
import './style';

const CheckInModal2 = ({
  isOpen,
  config,
  attendeeDetails,
  resourceMapping,
  ticketCount,
  selectedAttendees,
  setSelectedAttendees,
  toggleSelectAttendee,
  handleCheckIn,
  eventQuestions,
  getAttendeeResponse,
  onClose,
}) => {

  const [selectAll, setSelectAll] = useState(false)
  const [activeAccordion, setActiveAccordion] = useState(null);

  const notCheckedInAttendees = resourceMapping?.filter((item) => !item?.is_checked_in)?.length

  const toggleAccordion = (index) => {
    setActiveAccordion((prev) => (prev === index ? null : index));
  };

  return (
    <Modal
      size="medium"
      isOpen={isOpen}
      primaryText="Checkin"
      title={
        <h1 className="heading-24">
          Group Ticket Details{' '}
          <span className="text-primary">
            ({config?.ticket_details[0]?.category})
          </span>
        </h1>
      }
      hasClose={true}
      onClose={onClose}
      className="checkIn-modal2"
    >
      <div className="flex flex-col gap-6 w-auto h-[320px] overflow-y-scroll pb-[15px]">
        <div className="flex justify-between items-center">
          <Checkbox
            label="Select All"
            onChange={(e) => {
              setSelectAll(prev => !prev)
              if (selectAll) {
                setSelectedAttendees([]);
              } else {
                setSelectedAttendees(resourceMapping.map((item, index) => !item?.is_checked_in ? index : null).filter((idx) => idx !== null));
              }
            }}
            checked={selectAll}
          />
          <h5 className="text-sm font-medium">
            {selectedAttendees.length}/{notCheckedInAttendees} Selected
          </h5>
        </div>

        {/* checked in attendees list */}
        {ticketCount > 0 && (
          <Accordion
            title="Checked in Tickets"
            content={
              <div className="flex flex-col gap-2">
                {attendeeDetails.map((attendee, index) => (
                  resourceMapping?.[index]?.is_checked_in ? (
                    <div key={index} className="flex items-center gap-4">
                      <Checkbox
                        className="attendee-label"
                        label={attendee?.full_name}
                        checked={true}
                      />
                    </div>
                  ):null
                ))}
              </div>
            }
            className="text-base attendee-detail2"
          />
        )}

        <div className="w-full border-t-grey-10 border-t border-solid"></div>

        {/* not checked in attendees list */}
        {attendeeDetails?.map((attendee, index) => (
          resourceMapping?.[index]?.is_checked_in ? null : (
            <Checkbox
              key={index}
              className="attendee-label"
              label={
                <Accordion
                  content={
                    <div className="flex flex-col gap-2 text-sm font-medium">
                      {Object.keys(attendee || {}).map((item) =>
                        eventQuestions?.[item]?.id !== 'full_name' ? (
                          <div
                            key={item}
                            className="flex flex-row justify-between"
                          >
                            <h6>
                              {eventQuestions?.[item]?.label ||
                                item?.replace(/^./, item[0]?.toUpperCase())}
                            </h6>
                            <h6 className="text-black">
                              {getAttendeeResponse(
                                eventQuestions?.[item],
                                item,
                                attendee?.[item]
                              )}
                            </h6>
                          </div>
                        ) : null
                      )}
                      <div className="flex flex-row justify-between">
                        <h6>Category</h6>
                        <h6 className="text-black">
                          {config?.ticket_details[0]?.category}
                        </h6>
                      </div>
                      <div className="flex flex-row justify-between">
                        <h6>Booking ID</h6>
                        <h6 className="text-black">{config?.bookingId}</h6>
                      </div>
                    </div>
                  }
                  title={attendee?.full_name}
                  className="text-base attendee-detail"
                  isOpen={activeAccordion === index}
                  onToggle={() => toggleAccordion(index)}
                />
              }
              checked={selectedAttendees.includes(index)}
              onChange={() => { toggleSelectAttendee(index); setSelectAll(false) }}
            />
          )
        ))}

        <div
          className={`absolute left-0 bottom-0 w-full flex flex-col justify-between items-center gap-2.5 px-12 py-6 
        bg-white border-t-[#F3F3F3] border-t border-solid rounded-e-xl rounded-s-xl`}
        >
          <Button
            className="w-full"
            onClick={() => { handleCheckIn(); setSelectAll(false)}}
            disabled={selectedAttendees.length === 0}
          >
            Check In
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CheckInModal2;
